/* eslint-disable @typescript-eslint/no-non-null-assertion */
declare global {
  interface Window {
    config: Config
  }
}

export interface Config {
  apiBaseHost: string;
  labelApiBaseHost: string;
  labelApiKey?: string;
  wsBaseHost: string;
  cdnUrl: string;
  gcp: {
    apiKey: string;
    authDomain: string;
    recaptchaKey: string;
  },
  app: {
    clientId: string;
    address: string;
    login: string;
    expertApp: string;
  },
  payments: {
    worldlineLegacyUrl: string;
    worldlineTokenizerUrl: string;
  }
  consultations: {
    written: {
      timeoutHours: number,
    },
  },
  tagManagerId: string;
  managedLanguages: string[];
  vapidPublicKey: string;
}

const config: Config = {
  labelApiKey: process.env.NEXT_PUBLIC_API_LABEL_KEY || undefined,
  labelApiBaseHost: process.env.NEXT_PUBLIC_LABEL_API_BASE_HOST || "",
  apiBaseHost: process.env.NEXT_PUBLIC_API_BASE_HOST || "",
  wsBaseHost: process.env.NEXT_PUBLIC_WS_BASE_HOST || "",
  cdnUrl: process.env.NEXT_PUBLIC_CDN_URL || "",
  gcp: {
    apiKey: process.env.NEXT_PUBLIC_GCP_API_KEY || "",
    authDomain: process.env.NEXT_PUBLIC_GCP_AUTH_DOMAIN || "",
    recaptchaKey: process.env.NEXT_PUBLIC_GCP_RECAPTCHA_KEY || "",
  },
  app: {
    clientId: process.env.NEXT_PUBLIC_APP_CLIENT_ID || "",
    address: process.env.NEXT_PUBLIC_APP_ADDRESS || "",
    login: process.env.NEXT_PUBLIC_APP_LOGIN || "",
    expertApp: process.env.NEXT_PUBLIC_EXPERT_ADDRESS || "",
  },
  payments: {
    worldlineLegacyUrl: process.env.NEXT_PUBLIC_WORLDLINE_LEGACY_URL || "",
    worldlineTokenizerUrl: process.env.NEXT_PUBLIC_WORLDLINE_TOKENIZER_URL || "",
  },
  consultations: {
    written: {
      timeoutHours: 24,
    },
  },
  tagManagerId: process.env.NEXT_PUBLIC_GTM_ID || "",
  managedLanguages: process.env.NEXT_PUBLIC_MANAGED_LANGUAGES!.split(",") || [],
  vapidPublicKey: process.env.NEXT_PUBLIC_VAPID_KEY || "",
};
export default config;
